export default "__VITE_ASSET__DTQkvll9__"